module.exports = __webpack_public_path__ + "img/Image 50.cc00c8b9.png";